/* eslint-disable no-extend-native */
export function extendJavascript() {
    extendArrayFunctionalities();
}

export function extendElementFunctionalities(elementId) {
    const element = document.getElementById(elementId);
    element.timeouts = [];
    element.addTimeout = t => addTimeout(element, t);
    element.deleteTimeout = t => deleteTimeout(element, t);
    element.deleteAllTimeouts = () => deleteAllTimeouts(element);
    element.hasNoTimeouts = () => hasNoTimeouts(element);
}

export function extendWindowFunctionalities() {
    Window.prototype.timeouts = [];
    Window.prototype.addTimeout = addTimeout;
    Window.prototype.deleteTimeout = deleteTimeout;
    Window.prototype.deleteAllTimeouts = deleteAllTimeouts;
    Window.prototype.hasNoTimeouts = hasNoTimeouts;
}

function addTimeout(element, timeout) {
    if (element.hasNoTimeouts()) element.timeouts.push(timeout);
}

function deleteTimeout(element, timeout) {
    // this.clearTimeout(timeout);
    let timeouts = element.timeouts;
    const index = timeouts.indexOf(timeout);
    const itHasBeenFound = index !== -1;
    if (itHasBeenFound) element.timeouts.splice(index, 1);
}

function deleteAllTimeouts(element) {
    let timeouts = element.timeouts;
    timeouts.forEach(timeout => {
        element.deleteTimeout(timeout);
    });
}

function hasNoTimeouts(element) {
    if (element.timeouts.length === 0) return true;
    else return false;
}

function extendArrayFunctionalities() {
    Array.prototype.isEmpty = function() {
        return this.length === 0;
    };
    Array.prototype.isNotEmpty = function() {
        return !this.isEmpty();
    };
    Array.prototype.selfConcat = function(array) {
        const type = typeof array;
        const isSingleNumber = type === "number";
        if (isSingleNumber) {
            const number = array;
            this.push(number);
        } else {
            array.forEach(element => {
                this.push(element);
            });
        }
    };
    Array.prototype.clone = function() {
        const array = this.getWithoutIndices([]);
        return array;
    };
    Array.prototype.sortNumbers = function() {
        const compareNumbers = (a, b) => a - b;
        const sortedArray = this.sort(compareNumbers);
        return sortedArray;
    };
    Array.prototype.hasArray = function(array) {
        const array2 = array;
        const value = this.find(array1 => JSON.stringify(array1) === JSON.stringify(array2));
        if (value !== undefined) return true;
        else return false;
    };
    Array.prototype.getMax = function() {
        let max = -Infinity;
        for (let i = 0; i < this.length; i++) {
            const element = this[i];
            if (element > max) max = element;
        }
        return max;
    };
    Array.prototype.getMean = function() {
        const N = this.length;
        const sum = this.getSum();
        const mean = sum / N;
        return mean;
    };
    Array.prototype.getSum = function() {
        let sum = 0;
        for (let i = 0; i < this.length; i++) {
            const element = this[i];
            sum += element;
        }
        return sum;
    };
    Array.prototype.getVariance = function() {
        let V = 0;
        const N = this.length;
        const a_ = this.getMean();
        for (let i = 0; i < this.length; i++) {
            const ai = this[i];
            const v = Math.pow(ai - a_, 2);
            V += v;
        }
        const variance = V / N;
        return variance;
    };
    Array.prototype.getDeviation = function() {
        const variance = this.getVariance();
        const sigma = Math.sqrt(variance);
        return sigma;
    };
    Array.prototype.getNormalizedWithMax = function() {
        let array = [];
        const max = this.getMax();
        for (let i = 0; i < this.length; i++) {
            const element = this[i];
            array[i] = element / max;
        }
        return array;
    };
    Array.prototype.getWithoutIndices = function(indices) {
        let array = [];
        for (let i = 0; i < this.length; i++) {
            const element = this[i];
            const itIsBannedIndex = indices.indexOf(i) !== -1;
            const itIsValidIndex = !itIsBannedIndex;
            if (itIsValidIndex) array.push(element);
        }
        return array;
    };
    Array.prototype.getWithoutValues = function(values) {
        let array = [];
        for (let i = 0; i < this.length; i++) {
            const element = this[i];
            const itIsBannedValue = values.indexOf(element) !== -1;
            const itIsValidValue = !itIsBannedValue;
            if (itIsValidValue) array.push(element);
        }
        return array;
    };
    Array.prototype.getRepeatedValues = function() {
        let values = [];
        this.forEach(value => {
            const index = this.indexOf(value);
            const array = this.getWithoutIndices([index]);
            const itIsRepeated = array.indexOf(value) !== -1;
            const itIsNotIncluded = values.indexOf(value) === -1;
            if (itIsRepeated && itIsNotIncluded) values.push(value);
        });
        return values;
    };
}
